import React from "react";
import { Link } from "react-router-dom";
import "./therapytype.css";
import {connect} from 'react-redux';
import { addTherapyType } from "../../../Redux/action";
import Footer from "../../../components/Footer/Footer";
import ProfileNavbar from "../../../components/Navbar/ProfileNavbar";

const TherapyType = ({addTherapyType, test}) => {

  return (
    <>
    <ProfileNavbar />
    <div className="type">
      <h1>Get Started with your Assessment Process</h1>
      <div className="choice">
        <h3>What are you here for?</h3>
        <div className="choice-btns">
          <Link to="/difficulties" onClick={() => addTherapyType("I need Therapy")}>
            <button>I need Therapy</button>
          </Link>
          <Link to="/gender" onClick={() => addTherapyType("Here to Help")}>
            <button>Here to Help</button>
          </Link>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

const mapDispatchToProps = { addTherapyType };
const mapStateToProps = (state) => {
  return {test: state?.therapyType}
}

export default connect(mapStateToProps, mapDispatchToProps)(TherapyType);
